import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react';
import { f as format } from '../../index-ccef08fe.js';
import SuggestedMentionList from './SuggestedMentionList.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { u as useChannelContext, a as isDisabledBecauseFrozen, b as isDisabledBecauseMuted } from '../../ChannelProvider-5dcbee7b.js';
import { h as getClassName } from '../../index-579ca9d7.js';
import { M as MAX_USER_MENTION_COUNT, a as MAX_USER_SUGGESTION_COUNT } from '../../const-72f012b6.js';
import DateSeparator from '../../ui/DateSeparator.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import MessageInput from '../../ui/MessageInput.js';
import MessageContent from '../../ui/MessageContent.js';
import FileViewer from './FileViewer.js';
import RemoveMessage from './RemoveMessageModal.js';
import { M as MessageInputKeys } from '../../const-3a34a127.js';
import { u as useLocalization } from '../../LocalizationContext-a82461b5.js';
import { a as useHandleOnScrollCallback } from '../../index-dd5a8777.js';
import { u as useDirtyGetMentions } from '../../useDirtyGetMentions-dffd4046.js';
import '../../index-6add7940.js';
import '../../ui/Icon.js';
import 'prop-types';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../uuid-717930b4.js';
import '../../ThreadProvider-cf357120.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
import '../../topics-eb548880.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../withSendbird.js';
import '../../compareIds-2e50e905.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../color-91e43dce.js';
import '../../stringSet-b60e9529.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import 'dompurify';
import '../../consts-b4cb83cf.js';
import '../../consts-7693b8d3.js';
import '../../consts-9469111b.js';
import '../../tokenize-c718324d.js';
import '../../index.module-4f1cd64e.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../utils-e0c7329c.js';
import '../../index-ac0b2d20.js';
import '../../ui/Loader.js';
import '../../index-f879f6ef.js';
import '../../index-ad50e2c0.js';
import '../../ui/MessageItemMenu.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../types-95cfd227.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../useLongPress-12280c78.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../index-a9101009.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/TextMessageItemBody.js';
import '../../index-a2bb2783.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/OGMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/QuoteMessage.js';
import '../../index-86294a68.js';
import '../../ui/ThreadReplies.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../index-fa5b2b8c.js';
import '../../VoiceRecorder/context.js';
import '../../ui/Modal.js';
import '../../ui/PlaybackTime.js';
var useDidMountEffect = function useDidMountEffect(func, deps) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    didMount = _useState2[0],
    setDidmount = _useState2[1];
  useEffect(function () {
    if (didMount) {
      func();
    } else {
      setDidmount(true);
    }
  }, deps);
};

// todo: Refactor this component, is too complex now
var Message = function Message(_ref) {
  var _message$reactions, _message$isUserMessag;
  var message = _ref.message,
    hasSeparator = _ref.hasSeparator,
    chainTop = _ref.chainTop,
    chainBottom = _ref.chainBottom,
    handleScroll = _ref.handleScroll,
    handleMessageListHeightChange = _ref.handleMessageListHeightChange,
    renderCustomSeparator = _ref.renderCustomSeparator,
    renderEditInput = _ref.renderEditInput,
    renderMessage = _ref.renderMessage,
    renderMessageContent = _ref.renderMessageContent;
  var _useLocalization = useLocalization(),
    dateLocale = _useLocalization.dateLocale;
  var globalStore = useSendbirdStateContext();
  var _globalStore$config = globalStore.config,
    userId = _globalStore$config.userId,
    isOnline = _globalStore$config.isOnline,
    isMentionEnabled = _globalStore$config.isMentionEnabled,
    userMention = _globalStore$config.userMention,
    logger = _globalStore$config.logger;
  var maxUserMentionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || MAX_USER_MENTION_COUNT;
  var maxUserSuggestionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || MAX_USER_SUGGESTION_COUNT;
  var _useChannelContext = useChannelContext(),
    initialized = _useChannelContext.initialized,
    currentGroupChannel = _useChannelContext.currentGroupChannel,
    highLightedMessageId = _useChannelContext.highLightedMessageId,
    setHighLightedMessageId = _useChannelContext.setHighLightedMessageId,
    animatedMessageId = _useChannelContext.animatedMessageId,
    setAnimatedMessageId = _useChannelContext.setAnimatedMessageId,
    updateMessage = _useChannelContext.updateMessage,
    scrollToMessage = _useChannelContext.scrollToMessage,
    replyType = _useChannelContext.replyType,
    threadReplySelectType = _useChannelContext.threadReplySelectType,
    isReactionEnabled = _useChannelContext.isReactionEnabled,
    toggleReaction = _useChannelContext.toggleReaction,
    emojiContainer = _useChannelContext.emojiContainer,
    nicknamesMap = _useChannelContext.nicknamesMap,
    setQuoteMessage = _useChannelContext.setQuoteMessage,
    resendMessage = _useChannelContext.resendMessage,
    renderUserMentionItem = _useChannelContext.renderUserMentionItem,
    onReplyInThread = _useChannelContext.onReplyInThread,
    onQuoteMessageClick = _useChannelContext.onQuoteMessageClick,
    onMessageAnimated = _useChannelContext.onMessageAnimated,
    onMessageHighlighted = _useChannelContext.onMessageHighlighted,
    onScrollCallback = _useChannelContext.onScrollCallback;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEdit = _useState4[0],
    setShowEdit = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showRemove = _useState6[0],
    setShowRemove = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showFileViewer = _useState8[0],
    setShowFileViewer = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isAnimated = _useState0[0],
    setIsAnimated = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isHighlighted = _useState10[0],
    setIsHighlighted = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    mentionNickname = _useState12[0],
    setMentionNickname = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    mentionedUsers = _useState14[0],
    setMentionedUsers = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    mentionedUserIds = _useState16[0],
    setMentionedUserIds = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    messageInputEvent = _useState18[0],
    setMessageInputEvent = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedUser = _useState20[0],
    setSelectedUser = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    mentionSuggestedUsers = _useState22[0],
    setMentionSuggestedUsers = _useState22[1];
  var editMessageInputRef = useRef(null);
  var messageScrollRef = useRef(null);
  var displaySuggestedMentionList = isOnline && isMentionEnabled && mentionNickname.length > 0 && !isDisabledBecauseFrozen(currentGroupChannel) && !isDisabledBecauseMuted(currentGroupChannel);
  var disabled = !initialized || isDisabledBecauseFrozen(currentGroupChannel) || isDisabledBecauseMuted(currentGroupChannel) || !isOnline;
  var handleOnScroll = useHandleOnScrollCallback({
    hasMore: false,
    onScroll: onScrollCallback,
    scrollRef: messageScrollRef
  });
  var mentionNodes = useDirtyGetMentions({
    ref: editMessageInputRef
  }, {
    logger: logger
  });
  var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < maxUserMentionCount;
  useEffect(function () {
    setMentionedUsers(mentionedUsers.filter(function (_ref2) {
      var userId = _ref2.userId;
      var i = mentionedUserIds.indexOf(userId);
      if (i < 0) {
        return false;
      } else {
        mentionedUserIds.splice(i, 1);
        return true;
      }
    }));
  }, [mentionedUserIds]);

  /**
   * Move the messsage list scroll
   * when the message's height is changed by `showEdit` OR `message.reactions`
   */
  useDidMountEffect(function () {
    handleScroll === null || handleScroll === void 0 ? void 0 : handleScroll();
  }, [showEdit, message === null || message === void 0 ? void 0 : (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length]);
  useLayoutEffect(function () {
    handleMessageListHeightChange === null || handleMessageListHeightChange === void 0 ? void 0 : handleMessageListHeightChange();
  }, []);
  useLayoutEffect(function () {
    var animationTimeout = null;
    var messageHighlightedTimeout = null;
    if (highLightedMessageId === message.messageId && messageScrollRef !== null && messageScrollRef !== void 0 && messageScrollRef.current) {
      handleOnScroll();
      setIsAnimated(false);
      animationTimeout = setTimeout(function () {
        setIsHighlighted(true);
      }, 500);
      messageHighlightedTimeout = setTimeout(function () {
        setHighLightedMessageId(0);
        onMessageHighlighted === null || onMessageHighlighted === void 0 ? void 0 : onMessageHighlighted();
      }, 1600);
    } else {
      setIsHighlighted(false);
    }
    return function () {
      clearTimeout(animationTimeout);
      clearTimeout(messageHighlightedTimeout);
    };
  }, [highLightedMessageId, messageScrollRef.current, message.messageId]);
  useLayoutEffect(function () {
    var animationTimeout = null;
    var messageAnimatedTimeout = null;
    if (animatedMessageId === message.messageId && messageScrollRef !== null && messageScrollRef !== void 0 && messageScrollRef.current) {
      handleOnScroll();
      setIsHighlighted(false);
      animationTimeout = setTimeout(function () {
        setIsAnimated(true);
      }, 500);
      messageAnimatedTimeout = setTimeout(function () {
        setAnimatedMessageId(0);
        onMessageAnimated === null || onMessageAnimated === void 0 ? void 0 : onMessageAnimated();
      }, 1600);
    } else {
      setIsAnimated(false);
    }
    return function () {
      clearTimeout(animationTimeout);
      clearTimeout(messageAnimatedTimeout);
    };
  }, [animatedMessageId, messageScrollRef.current, message.messageId, onMessageAnimated]);
  var renderedMessage = useMemo(function () {
    return renderMessage === null || renderMessage === void 0 ? void 0 : renderMessage({
      message: message,
      chainTop: chainTop,
      chainBottom: chainBottom
    });
  }, [message, renderMessage]);
  var renderedCustomSeparator = useMemo(function () {
    if (renderCustomSeparator) {
      return renderCustomSeparator === null || renderCustomSeparator === void 0 ? void 0 : renderCustomSeparator({
        message: message
      });
    }
    return null;
  }, [message, renderCustomSeparator]);
  if (renderedMessage) {
    return /*#__PURE__*/React__default.createElement("div", {
      // do not delete this data attribute, used for scroll to given message
      // and also for testing
      "data-sb-message-id": message.messageId,
      "data-sb-created-at": message.createdAt,
      ref: messageScrollRef,
      className: getClassName(['sendbird-msg-hoc sendbird-msg--scroll-ref', isAnimated ? 'sendbird-msg-hoc__animated' : '', isHighlighted ? 'sendbird-msg-hoc__highlighted' : ''])
    },
    // TODO: Add message instance as a function parameter
    hasSeparator && (renderedCustomSeparator || /*#__PURE__*/React__default.createElement(DateSeparator, null, /*#__PURE__*/React__default.createElement(Label, {
      type: LabelTypography.CAPTION_2,
      color: LabelColors.ONBACKGROUND_2
    }, format(message.createdAt, 'MMMM dd, yyyy', {
      locale: dateLocale
    })))), renderedMessage);
  }
  if (showEdit && message !== null && message !== void 0 && (_message$isUserMessag = message.isUserMessage) !== null && _message$isUserMessag !== void 0 && _message$isUserMessag.call(message)) {
    return (renderEditInput === null || renderEditInput === void 0 ? void 0 : renderEditInput()) || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, displaySuggestedMentionList && /*#__PURE__*/React__default.createElement(SuggestedMentionList, {
      targetNickname: mentionNickname,
      inputEvent: messageInputEvent,
      renderUserMentionItem: renderUserMentionItem,
      onUserItemClick: function onUserItemClick(user) {
        if (user) {
          setMentionedUsers([].concat(_toConsumableArray(mentionedUsers), [user]));
        }
        setMentionNickname('');
        setSelectedUser(user);
        setMessageInputEvent(null);
      },
      onFocusItemChange: function onFocusItemChange() {
        setMessageInputEvent(null);
      },
      onFetchUsers: function onFetchUsers(users) {
        setMentionSuggestedUsers(users);
      },
      ableAddMention: ableMention,
      maxMentionCount: maxUserMentionCount,
      maxSuggestionCount: maxUserSuggestionCount
    }), /*#__PURE__*/React__default.createElement(MessageInput, {
      isEdit: true,
      channel: currentGroupChannel,
      disabled: disabled,
      ref: editMessageInputRef,
      mentionSelectedUser: selectedUser,
      isMentionEnabled: isMentionEnabled,
      message: message,
      onStartTyping: function onStartTyping() {
        var _currentGroupChannel$;
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : (_currentGroupChannel$ = currentGroupChannel.startTyping) === null || _currentGroupChannel$ === void 0 ? void 0 : _currentGroupChannel$.call(currentGroupChannel);
      },
      onUpdateMessage: function onUpdateMessage(_ref3) {
        var _currentGroupChannel$2;
        var messageId = _ref3.messageId,
          message = _ref3.message,
          mentionTemplate = _ref3.mentionTemplate;
        updateMessage({
          messageId: messageId,
          message: message,
          mentionedUsers: mentionedUsers,
          mentionTemplate: mentionTemplate
        });
        setShowEdit(false);
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : (_currentGroupChannel$2 = currentGroupChannel.endTyping) === null || _currentGroupChannel$2 === void 0 ? void 0 : _currentGroupChannel$2.call(currentGroupChannel);
      },
      onCancelEdit: function onCancelEdit() {
        var _currentGroupChannel$3;
        setMentionNickname('');
        setMentionedUsers([]);
        setMentionedUserIds([]);
        setMentionSuggestedUsers([]);
        setShowEdit(false);
        currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : (_currentGroupChannel$3 = currentGroupChannel.endTyping) === null || _currentGroupChannel$3 === void 0 ? void 0 : _currentGroupChannel$3.call(currentGroupChannel);
      },
      onUserMentioned: function onUserMentioned(user) {
        if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
          setSelectedUser(null);
          setMentionNickname('');
        }
      },
      onMentionStringChange: function onMentionStringChange(mentionText) {
        setMentionNickname(mentionText);
      },
      onMentionedUserIdsUpdated: function onMentionedUserIdsUpdated(userIds) {
        setMentionedUserIds(userIds);
      },
      onKeyDown: function onKeyDown(e) {
        if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0 && (e.key === MessageInputKeys.Enter && ableMention || e.key === MessageInputKeys.ArrowUp || e.key === MessageInputKeys.ArrowDown)) {
          setMessageInputEvent(e);
          return true;
        }
        return false;
      }
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: getClassName(['sendbird-msg-hoc sendbird-msg--scroll-ref', isAnimated ? 'sendbird-msg-hoc__animated' : '', isHighlighted ? 'sendbird-msg-hoc__highlighted' : '']),
    style: {
      marginBottom: '2px'
    },
    "data-sb-message-id": message.messageId,
    "data-sb-created-at": message.createdAt,
    ref: messageScrollRef
  }, hasSeparator && (renderedCustomSeparator || /*#__PURE__*/React__default.createElement(DateSeparator, null, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.CAPTION_2,
    color: LabelColors.ONBACKGROUND_2
  }, format(message.createdAt, 'MMMM dd, yyyy', {
    locale: dateLocale
  })))), (renderMessageContent === null || renderMessageContent === void 0 ? void 0 : renderMessageContent()) || /*#__PURE__*/React__default.createElement(MessageContent, {
    className: "sendbird-message-hoc__message-content",
    userId: userId,
    scrollToMessage: scrollToMessage,
    channel: currentGroupChannel,
    message: message,
    disabled: !isOnline,
    chainTop: chainTop,
    chainBottom: chainBottom,
    isReactionEnabled: isReactionEnabled,
    replyType: replyType,
    threadReplySelectType: threadReplySelectType,
    nicknamesMap: nicknamesMap,
    emojiContainer: emojiContainer,
    showEdit: setShowEdit,
    showRemove: setShowRemove,
    showFileViewer: setShowFileViewer,
    resendMessage: resendMessage,
    toggleReaction: toggleReaction,
    setQuoteMessage: setQuoteMessage,
    onReplyInThread: onReplyInThread,
    onQuoteMessageClick: onQuoteMessageClick,
    onMessageHeightChange: handleScroll
  }), showRemove && /*#__PURE__*/React__default.createElement(RemoveMessage, {
    message: message,
    onCancel: function onCancel() {
      return setShowRemove(false);
    }
  }), showFileViewer && /*#__PURE__*/React__default.createElement(FileViewer, {
    message: message,
    onCancel: function onCancel() {
      return setShowFileViewer(false);
    }
  }));
};
export { Message as default };